/**
 * BrandLogo — RegenX Wellness wordmark
 * Variants: "compact" (wordmark + WELLNESS rule, for header)
 *           "stacked" (wordmark + WELLNESS rule, centered)
 *           "full"    (stacked + italic tagline, for age gate)
 */
const NAVY = "#0F2A44";
const SAGE = "#7FA88A";

export default function BrandLogo({ variant = "compact", className = "" }) {
  if (variant === "stacked" || variant === "full") {
    return (
      <div
        className={`flex flex-col items-center text-center leading-none ${className}`}
        data-testid="brand-logo-stacked"
      >
        <span
          className="editorial-heading text-5xl md:text-6xl tracking-tight"
          style={{ letterSpacing: "0.04em" }}
        >
          <span style={{ color: NAVY }}>REGEN</span>
          <span style={{ color: SAGE }}>X</span>
        </span>
        <span
          className="mt-5 text-[11px] tracking-[0.55em] font-medium flex items-center gap-3"
          style={{ color: NAVY }}
        >
          <span
            aria-hidden="true"
            className="inline-block h-px w-8"
            style={{ background: SAGE }}
          />
          WELLNESS
          <span
            aria-hidden="true"
            className="inline-block h-px w-8"
            style={{ background: SAGE }}
          />
        </span>
        {variant === "full" && (
          <>
            <span
              aria-hidden="true"
              className="inline-block h-px w-10 mt-6"
              style={{ background: SAGE }}
            />
            <span
              className="font-serif italic text-lg md:text-xl mt-5"
              style={{ color: SAGE }}
            >
              Restore. Renew. Thrive.
            </span>
          </>
        )}
      </div>
    );
  }

  // compact — for header
  return (
    <div
      className={`flex flex-col leading-none ${className}`}
      data-testid="brand-logo-compact"
    >
      <span
        className="editorial-heading text-2xl md:text-[28px] tracking-tight"
        style={{ letterSpacing: "0.04em" }}
      >
        <span style={{ color: NAVY }}>REGEN</span>
        <span style={{ color: SAGE }}>X</span>
      </span>
      <span
        className="mt-1.5 text-[8px] tracking-[0.42em] font-medium hidden sm:flex items-center gap-1.5"
        style={{ color: NAVY }}
      >
        <span
          aria-hidden="true"
          className="inline-block h-px w-3"
          style={{ background: SAGE }}
        />
        WELLNESS
        <span
          aria-hidden="true"
          className="inline-block h-px w-3"
          style={{ background: SAGE }}
        />
      </span>
    </div>
  );
}
